import Vue from 'vue'
import Router from 'vue-router'
const Index = resolve => require(['@/page/index'], resolve)
const About = resolve => require(['@/page/about'], resolve)
const DownLoad = resolve => require(['@/page/download'], resolve)


const ClassifyList = resolve => require(['@/page/classifyList'], resolve)
const Search = resolve => require(['@/page/search'], resolve)
const ArticleDetail = resolve => require(['@/page/articleDetail'], resolve)

const Chepai = resolve => require(['@/page/chepai'], resolve)
const Weizhang = resolve => require(['@/page/weizhang'], resolve)
const Shixinren = resolve => require(['@/page/shixinren/shixinren'], resolve)
const Suanhua = resolve => require(['@/page/suanhua/suanhua'], resolve)
const Themis = resolve => require(['@/page/themis'], resolve)
const Pay = resolve => require(['@/page/pay'], resolve)

const SelectVin = resolve => require(['@/page/selectVin'], resolve)
const WeiBao = resolve => require(['@/page/weiBao'], resolve)


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: About
    },
    {
        path:'/classifyList',
        name: '分类页',
        component:ClassifyList
    },
    {
        path:'/search',
        name: '搜索结果页',
        component:Search
    },
    {
        path:'/articleDetail',
        name: '文章详情',
        component:ArticleDetail
    },
    {
      path: '/about',
      name: '关于我们',
      component: About
    },{
      path: '/download',
      name: 'APP下载',
      component: DownLoad
    },{
      path: '/chepai',
      name: '车牌查询',
      component: Chepai
    },{
      path: '/weizhang',
      name: '违章查询',
      component: Weizhang
    },{
      path: '/shixinren',
      name: '失信人查询',
      component: Shixinren
    },{
      path: '/suanhua',
      name: '算话征信',
      component: Suanhua
    },{
      path: '/themis',
      name: '风险报告',
      component: Themis
    },{
      path: '/pay',
      name: '支付页面',
      component: Pay
    },{
      path: '/selectVin',
      name: 'VIN码查询',
      component: SelectVin
    },{
      path: '/weiBao',
      name: '维修保养查询',
      component: WeiBao
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js